import type {TranslationParams} from '@app/hooks/useTranslation';
import {type Offer, OfferId, type SubscriptionPeriod} from './types';

export const OffersToCheck = [
	OfferId.Premium,
	OfferId.PremiumWithHifi,
	OfferId.DuoWithHifi,
	OfferId.Family,
	OfferId.FamilyWithHifi,
];

export function getNumberOfMonthsFromPeriod(
	data: Pick<SubscriptionPeriod, 'duration' | 'duration_type' | 'iteration'>,
): number {
	if (data.duration_type === 'M') {
		return data.duration * (data.iteration || 1);
	}
	if (data.duration_type === 'Y') {
		return data.duration * 12 * (data.iteration || 1);
	}
	return 0;
}

export function getWording(offerData: Offer[]): TranslationParams | null {
	let monthsOfTnb = 0;
	let daysOfTnb = 0;
	let trialPrice: string | null = null;

	// Loop through offerData
	for (const offer of offerData) {
		// Verify that the offer id is in OffersToCheck and that it is public
		if (OffersToCheck.includes(offer.offer_id) && offer.public) {
			const tnbPeriod = offer.subscription_period_collection.try_and_buy;
			// Add the try_and_buy period to monthsOfTnb if it's greater than the current value
			if (tnbPeriod) {
				const months = getNumberOfMonthsFromPeriod(tnbPeriod);
				if (months > monthsOfTnb) {
					monthsOfTnb = months;
				}
				if (tnbPeriod.duration_type === 'D' && tnbPeriod.duration > daysOfTnb) {
					daysOfTnb = tnbPeriod.duration;
				}
				// No need to go further, we know that we will always return data from tnb if we have one
				break;
			}

			// If there is no try_and_buy period, get the initial period
			const initialPeriod = offer.subscription_period_collection.initial;

			// Add the initial period to the trialPrice if it's not null
			if (initialPeriod) {
				//! We don't set the minimum price as we don't have access to the integer value
				trialPrice = initialPeriod.price_by_month ?? null;
			}
		}
	}

	if (monthsOfTnb > 0) {
		return [
			'offer.uptoXmonthfree',
			{sprintf: [monthsOfTnb], count: monthsOfTnb},
		];
	}
	if (trialPrice !== null) {
		return ['offer.pricefromXpermonth', {sprintf: [trialPrice]}];
	}
	if (daysOfTnb > 0) {
		return ['offer.uptoXdaysfree', {sprintf: [daysOfTnb], count: daysOfTnb}];
	}
	return null;
}
